/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_P1_BodyInputs */

const es_cap_p1_body = /** @type {(inputs: Cap_P1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los armadores y la plataforma generan la demanda. Las propuestas de salida te llegan a ti — no tienes que salir a venderte.`)
};

const gl_cap_p1_body = /** @type {(inputs: Cap_P1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os armadores e a plataforma xeran a demanda. As propostas de saída chegan a ti — non tes que saír a venderte.`)
};

const en_cap_p1_body = /** @type {(inputs: Cap_P1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owners and the platform generate demand. Trip proposals come to you — you do not have to sell yourself.`)
};

/**
* | output |
* | --- |
* | "Owners and the platform generate demand. Trip proposals come to you — you do not have to sell yourself." |
*
* @param {Cap_P1_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_p1_body = /** @type {((inputs?: Cap_P1_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_P1_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_p1_body(inputs)
	if (locale === "en") return en_cap_p1_body(inputs)
	return es_cap_p1_body(inputs)
});